import { TLabel } from '../../types/auth';
import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export enum ETrackLabelActionTypes {
  SetTrackLabel = 'TRACK/SetTrackLabel',
}

export const setTrackLabel = actionGenerator<ETrackLabelActionTypes.SetTrackLabel, TLabel>(
  ETrackLabelActionTypes.SetTrackLabel,
);

export type TSetTrackLabel = ITypedReduxAction<ETrackLabelActionTypes.SetTrackLabel, TLabel>;
